import { addToGlobalThisRet } from "@plugins";

function initMenuCollapseToggler() {
    const menuList = document.querySelector(".js-menu-list");

    if (menuList) {
        for (let i = 0; i < menuList.children.length; i++) {
            const submenu = menuList.children[i].querySelector(".js-submenu-list");

            if (submenu) {
                const submenuTitle = menuList.children[i].querySelector(".js-menu-list-item");

                menuList.children[i].classList.add("collapsed");
                submenuTitle.addEventListener("click", () => {
                    menuList.children[i].classList.toggle("collapsed");
                });
            }
        }
    }
}

window.addEventListener("load", () => {
    initMenuCollapseToggler();
});

addToGlobalThisRet(initMenuCollapseToggler, "initMenuCollapseToggler");
